import(/* webpackMode: "eager", webpackExports: ["TalentLoginPage"] */ "/app/apps/platform-web/components/talent/auth/TalentLoginPage.tsx");
